import { CouponItem } from '@shopby/shop-sdk';
import { OptionType } from '@shopby/shop-sdk/build/types/domain/product/option/unions';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Product } from '../../@types/coupon';
import { getSubmitCoupons } from '../../api/coupons';
import { fadeIn, fadeOut, slideDown, slideUp } from '../../js/animation';
import { plusComma } from '../../js/script';

interface PropsType {
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
  orderSheetNo: number;
  selectCoupon: any;
  setProductCoupon: React.Dispatch<React.SetStateAction<any>>;
  productCoupon: any;
  setCouponText: any;
  couponText: any;
}

/**
 * 모달 팝업 - 아래 꽉참
 *
 * @params {React.ReactNode} content - 콘텐츠 내용
 * @params {string} headerText - 모달 헤더 제목
 */

export default function OrderModal({
  setIsModal,
  orderSheetNo,
  selectCoupon,
  setProductCoupon,
  productCoupon,
  setCouponText,
  couponText,
}: PropsType) {
  const [closing, setClosing] = useState<boolean>(false); // 닫힘 애니메이션 적용에 필요
  const [item, setItem] = useState<Product[]>([]);
  const [couponArray, setCouponArray] = useState<CouponItem[]>();
  const [optionNoArray, setOptionNoArray] = useState<OptionType[]>([]);
  const [selectArrayNo, setSelectArrayNo] = useState<number[]>([]);
  const [productCouponCopy, setProductCouponCopy] = useState<any>(null);

  const closeModal = () => {
    setClosing(true);
    setTimeout(() => {
      setIsModal(false);
      setClosing(false);
    }, 280);
  };

  // body 스크롤 제어
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  useEffect(() => {
    const copy = [...productCoupon];
    setProductCouponCopy(copy);
  }, [productCoupon]);

  useEffect(() => {
    getSubmitCoupons(orderSheetNo)
      .then((res) => {
        const array: any = [];
        res.data.products.map((el: any) => {
          if (el.productNo === selectCoupon) {
            array.push(el);
          }
        });
        setItem(array);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (productCoupon) {
      const array: any = [];
      productCoupon.map((el: any) => {
        array.push(el.couponIssueNo);
      });
      setOptionNoArray(array);
    }
  }, [productCoupon]);

  useEffect(() => {
    if (productCouponCopy) {
      const array: any = [];
      productCouponCopy?.map((el: any) => {
        array.push(el.couponIssueNo);
      });
      setSelectArrayNo(array);
    }
  }, [productCouponCopy]);

  // if (!isModal) return null;
  return (
    <ModalWrap>
      <ModalBox closing={closing}>
        <ModalHeader>
          <p>
            사용 가능 쿠폰
            <span>{item[0]?.productCoupons ? item[0]?.productCoupons?.length - optionNoArray.length : 0}</span>
          </p>
          <button onClick={closeModal}>
            <img src="../images/icon_close.png" alt="닫기" />
          </button>
        </ModalHeader>
        <ModalBody>
          <CouponBox>
            {item?.map((element: any) => {
              return element.productCoupons?.map((el: any, idx: number) => {
                if (optionNoArray?.includes(el.couponIssueNo)) {
                  return null;
                } else {
                  return (
                    <>
                      {element.productCoupons === 0
                        ? () => {
                            console.log('쿠폰이 없습니다.');
                          }
                        : null}
                      <CouponItems key={el.couponIssueNo}>
                        <input
                          type="radio"
                          id={`coupon${idx}`}
                          style={{
                            border: '0',
                            padding: '0',
                            fontSize: '0',
                            lineHeight: 'inherit',
                            color: 'transparent',
                            letterSpacing: '0',
                            margin: '0',
                            display: 'none',
                          }}
                          onChange={(e) => {
                            const couponApplyObj = {
                              couponIssueNo: el.couponIssueNo,
                              promotionCode: null,
                              productNo: selectCoupon,
                            };
                            const textObj = {
                              productNo: selectCoupon,
                              text: `${el.couponName} ${plusComma(el.couponDiscountAmt)}`,
                              couponIssueNo: el.couponIssueNo,
                              price: el.couponDiscountAmt,
                            };
                            const array: any = [...productCouponCopy];
                            const array1: any = [...couponText];
                            let couponbol: boolean = true;
                            let textbol: boolean = true;
                            array.map((el: any) => {
                              if (Number(el.productNo) === Number(selectCoupon)) {
                                couponbol = false;
                              }
                            });
                            if (couponbol) {
                              array.push(couponApplyObj);
                            } else {
                              for (let i = 0; i < array.length; i++) {
                                if (Number(array[i].productNo) === Number(selectCoupon)) {
                                  array[i].couponIssueNo = el.couponIssueNo;
                                }
                              }
                            }
                            array1.map((el: any) => {
                              if (Number(el.productNo) === Number(selectCoupon)) {
                                textbol = false;
                              }
                            });
                            if (textbol) {
                              array1.push(textObj);
                            } else {
                              for (let i = 0; i < array.length; i++)
                                if (Number(array1[i].productNo) === Number(selectCoupon)) {
                                  array1[i] = textObj;
                                }
                            }
                            const obj = {
                              cartCouponIssueNo: null,
                              channelType: null,
                              promotionCode: null,
                              productCoupons: array,
                            };
                            setCouponArray(array1);
                            setProductCouponCopy(array);
                          }}
                          name="coupon_radio"
                        />
                        <label
                          htmlFor={`coupon${idx}`}
                          style={{
                            padding: '20px',
                            border: selectArrayNo.includes(el.couponIssueNo)
                              ? '1px solid var(--colPointBlue)'
                              : '1px solid var(--colGray3)',
                            borderRadius: '6px',
                            display: 'block',
                          }}
                        >
                          <div>
                            <p
                              style={{
                                fontSize: '15px',
                                lineHeight: '20px',
                                color: 'var(--colBlack)',
                              }}
                            >
                              {el.couponName}
                            </p>
                            <span
                              style={{
                                fontSize: '12px',
                                lineHeight: '15px',
                                color: 'var(--colGray6)',
                                display: 'block',
                                marginTop: '4px',
                              }}
                            >
                              {`최대 ${
                                el.maxDiscountAmt ? plusComma(el.maxDiscountAmt) : plusComma(el.couponDiscountAmt)
                              }원 할인`}
                            </span>
                            <strong
                              style={{
                                fontSize: '24px',
                                lineHeight: '26px',
                                color: 'var(--colPointBlue)',
                                display: 'block',
                                marginTop: '8px',
                              }}
                            >
                              {plusComma(el.couponDiscountAmt)}원
                            </strong>
                          </div>
                        </label>
                      </CouponItems>
                    </>
                  );
                }
              });
            })}
          </CouponBox>
        </ModalBody>
        <ModalFooter>
          <div
            style={{
              width: '100%',
              textAlign: 'center',
              borderRadius: '5px',
              border: '1px solid var(--colGray3)',
              fontSize: '14px',
              lineHeight: '46px',
            }}
            onClick={() => {
              setProductCoupon(productCoupon);
              closeModal();
            }}
          >
            취소
          </div>

          <div
            style={{
              width: '100%',
              textAlign: 'center',
              borderRadius: '5px',
              background: 'var(--colBlack)',
              color: 'var(--colWhite)',
              fontSize: '14px',
              lineHeight: '48px',
            }}
            onClick={() => {
              if (couponArray) {
                setCouponText(couponArray);
              }
              setProductCoupon(productCouponCopy);

              closeModal();
            }}
          >
            확인
          </div>
        </ModalFooter>
      </ModalBox>
      <ModalBackground onClick={closeModal} closing={closing}></ModalBackground>
    </ModalWrap>
  );
}

interface typeProps {
  closing?: boolean;
}

export const ModalBackground = styled.div<typeProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
`;

export const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 900;
`;

export const ModalBox = styled.div<typeProps>`
  width: 100%;
  background-color: var(--colWhite);
  border-radius: 22px 22px 0 0;
  animation: ${({ closing }) => (closing ? slideDown : slideUp)} 0.3s ease-in-out;
  position: absolute;
  z-index: 30;
  display: flex;
  flex-direction: column;
  bottom: 0;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 18.5px 22px 0 33px;
  align-items: center;
  gap: 8px;
  & p {
    flex: 1;
    font-size: 20px;
    line-height: 24px;
    font-weight: 600;
    span {
      display: inline-block;
      color: var(--colPointBlue);
      margin-left: 4px;
    }
  }
  & button {
    border: none;
    background: transparent;
    width: 41px;
    height: 48px;
    padding: 12px 8px 12px 9px;
    & img {
      width: 100%;
      height: 100%;
    }
  }
`;

export const ModalBody = styled.div`
  padding: 8px 33px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 33px;
`;

export const CouponBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 328px;
  min-height: 129px;
  overflow-y: auto;
`;

export const CouponItems = styled.div``;
